import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Segment,
  Header,
  Transition,
  Table
} from "semantic-ui-react";
import FilaAsistencias from "./tablaAsistencias/FilaAsistencias";
import _ from "lodash";

const propTypes = {
  datos: PropTypes.array.isRequired,
  filtros: PropTypes.object
};

class TablaAsistencias extends React.Component {
  state = {
    column: this.props.filtros === null ? "nombre" : "edad",
    data: _.sortBy(this.props.datos, ["apellido1"]),
    direction: "ascending"
  };

  render() {
    const { data } = this.state;
    const { filtros, colegio } = this.props;
    const provincia = colegio.provincia.toUpperCase();

    return (
      <Transition.Group animation="scale" duration={250}>
        {!_.isEmpty(data) && (
          <Container fluid>
            <Segment basic>
              <Header as="h2" textAlign="center">
                {colegio.nombre}
              </Header>
              <Table celled structured>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center" colSpan={5}>
                      DATOS DEL ALUMNO
                      {filtros &&
                        `  (de ${filtros.desde} a ${filtros.hasta} años)`}
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      textAlign="center"
                      colSpan={provincia === "MURCIA" ? 7 : 6}
                    >
                      CONTROL DE ASISTENCIA
                    </Table.HeaderCell>
                  </Table.Row>

                  <Table.Row>
                    <Table.HeaderCell content="Nombre" />
                    <Table.HeaderCell content="Apellidos" />
                    <Table.HeaderCell content="Edad" />
                    <Table.HeaderCell content="Telefonos" />
                    <Table.HeaderCell content="Servicios" />
                    {colegio.provincia.toUpperCase() === "MURCIA" && (
                      <Table.HeaderCell textAlign="center" content="26" />
                    )}
                    {colegio.provincia.toUpperCase() === "MURCIA" && (
                      <Table.HeaderCell textAlign="center" content="27" />
                    )}
                    {colegio.provincia.toUpperCase() === "MURCIA" && (
                      <Table.HeaderCell textAlign="center" content="28" />
                    )}

                    <Table.HeaderCell textAlign="center" content="2" />
                    {colegio.provincia.toUpperCase() === "ALICANTE" && (
                      <Table.HeaderCell textAlign="center" content="3" />
                    )}
                    <Table.HeaderCell textAlign="center" content="4" />
                    <Table.HeaderCell textAlign="center" content="5" />
                    <Table.HeaderCell textAlign="center" content="6" />
                    {colegio.provincia.toUpperCase() === "ALICANTE" && (
                      <Table.HeaderCell textAlign="center" content="9" />
                    )}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {data.map(d => (
                    <FilaAsistencias
                      key={d.idInscripcion}
                      {...d}
                      dias={provincia === "MURCIA" ? 7 : 6}
                    />
                  ))}
                </Table.Body>
              </Table>
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

TablaAsistencias.propTypes = propTypes;

export default TablaAsistencias;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/listaInscripciones/TablaAsistencias.jsx